import SearchList from './SearchList';

export default SearchList;